import axios from "axios"
const baseUrl = process.env.VUE_APP_BASE_URL
const homeowners = 
{
    namespaced: true,
    state: {
        homeowners: [],
        homeowner: {}
    },
    mutations: {
        SET_HOMEOWNERS(state, data)
        {
            state.homeowners = data
        },
        SET_HOMEOWNER(state, data)
        {
            state.homeowner = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios
          .get(baseUrl+'homeowners/', { withCredentials: true })
          .then(res => {
                commit('SET_HOMEOWNERS', res.data)
                
          })
          .catch(error => console.log(error))
        },

        deleteHomeOwner ({ commit }, id) {
            return axios
            .get(baseUrl+'homeowners/delete?homeOwnerId=' + id, { withCredentials: true })
            
            .catch(error => console.log(error))
          },
          updateHomeOwner({ commit }, homeowner){
            return axios
            .post(baseUrl+'homeowners/homeowner', homeowner, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getHomeOwner ({ commit },id) {
            return axios
    
            .get(baseUrl+'homeowners/homeowner?homeOwnerId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_HOMEOWNER', res.data)
            })
            .catch(error => console.log(error))
        },
        addHomeOwner ({ commit }, homeowner) {
            return axios
  
            .post(baseUrl+'homeowners/homeowner', homeowner, { withCredentials: true })
            .then(res => {
               // console.log(res.data)
               commit('SET_HOMEOWNER', res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default homeowners